import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Transition } from 'react-transition-group';

import styles from './DesktopView.styl';

const cx = classNames.bind(styles);

const duration = 350;

const defaultStyle = {
  opacity: 0,
  transition: `opacity ${duration}ms`,
};

const transitionStyles = {
  entering: {
    opacity: 0,
  },
  entered: {
    opacity: 1,
  },
};

const Overlay = ({ isOpen, ...otherProps }) => (
  <Transition in={isOpen} timeout={duration} mountOnEnter unmountOnExit>
    {state => (
      <div
        {...otherProps}
        className={cx('FreeSaucesPanel__overlay')}
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      />
    )}
  </Transition>
);

Overlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default Overlay;
